// export const server = "http://localhost/NanniesDesk/NanniesDeskServer";
// export const UIUrl = "http://localhost:3000";

export const server = "https://nanniesdesk.com/NanniesDeskServer";
export const UIUrl = "https://nanniesdesk.com";
